import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import {
  alpha,
  styled,
} from '@mui/material/styles';
import { typographyClasses } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';

export const AccountAvatar = styled(Avatar)({
  width: 32,
  height: 32,
  backgroundColor: 'transparent',
});

export const AccountsListButton = styled(ListItemButton)(({ theme }) => ({
  'height': 42,
  'borderRadius': 8,
  'paddingLeft': 0,
  'backgroundColor': 'transparent',
  [`& .${typographyClasses.root}`]: {
    color: theme.palette.text.secondary,
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

export const AccountName = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: '17px',
  fontWeight: 600,
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
}));

export const AccountTypeLabel = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  lineHeight: '15px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
}));

export const Text = styled(Typography)(({ theme }) => ({
  'fontSize': 12,
  'lineHeight': '16px',
  'color': alpha(theme.palette.text.primary, 0.5),
  'fontFamily': theme.typography.fontFamily,
  '& span': {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
}));

export const Label = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
}));

export const Explainer = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.fontFamily,
  textAlign: 'center',
  fontWeight: 400,
  marginTop: '5px',
  marginBottom: '5px',
}));

export const TierName = styled(Typography)(({ theme }) => ({
  fontSize: 22,
  lineHeight: '27px',
  fontWeight: 600,
  color: theme.palette.primary.main,
  fontFamily: theme.typography.fontFamily,
}));

export const ScoreWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: 520,
  borderRadius: 6,
  padding: '30px 20px 20px',
}));

export const ScoreItemWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 81,
  borderRadius: 6,
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  color: theme.palette.text.secondary,
  fontFamily: theme.typography.body1.fontFamily,
}));
